/**
 * DEMO-BUTTON-1 (a) — 'Run demo' starts the valuation robot on the
 * presenter's computer through the yansar-demo: link (set up once per PC by
 * scripts/demo/register_demo_protocol.ps1). Staff only (super_admin,
 * valuation_signer — stepRole), and only on a DEV or QA site.
 */
import { buttonVariants } from '@/components/ui/button'
import { useAuth } from '@/contexts/AuthContext'
import { stepRole } from './_steps'
import { demoEnvForHost, demoLink } from './_demoLink'

// DEMO-BUTTON-1: owner-approved, verbatim (OWNER_APPROVALS.log 2026-10-24 19:03).
const CLIENT_TEXT = {
  'demo.run': 'Run demo',
  'demo.setupNote': 'Needs the one-time setup on this computer.',
} as const

export function RunDemoButton({ hostname = window.location.hostname }: { hostname?: string }) {
  const { user } = useAuth()
  const env = demoEnvForHost(hostname)
  if (!env || stepRole(user?.role) === 'owner') return null
  return (
    <div className="flex items-center gap-3">
      <a href={demoLink(env)} className={buttonVariants({ variant: 'outline' })}>
        {CLIENT_TEXT['demo.run']}
      </a>
      <span className="text-xs text-gray-500">{CLIENT_TEXT['demo.setupNote']}</span>
    </div>
  )
}
